import { action } from 'easy-peasy';
import { IActionSetMoreStatusUsers } from '../types';
import { mergeUniqueBy } from '~/utils/pagination';

const setMoreStatusUsers: IActionSetMoreStatusUsers = action((state, payload) => {
  const hasMore = state.pagination.itemsPerPage === payload.users.length;

  const newItems = mergeUniqueBy(state.statusUsers.users, payload.users, item => item.id);

  state.statusUsers.users = [...newItems];
  state.statusUsers.total = payload.total;
  state.pagination.page += 1;
  state.pagination.hasMore = hasMore;
});

export default setMoreStatusUsers;
